import { Component } from '@angular/core';
import {
  DsButtonModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsModalModule, DsToastModel, DsToastService,
} from '@bmw-ds/components';
import { NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CrossBorderService } from '../../../services/crossborder.service';
import { UnitSearchReserveRequest } from '../../../models/unit-search-reserve.models';

@Component({
  selector: 'app-update-comment-modal',
  templateUrl: './update-comment-modal.html',
  imports: [DsModalModule, FormsModule, DsButtonModule, NgIf, NgForOf],
  styleUrls: ['../unit-update/unit-update-modal.scss'],
})
export class UpdateCommentModalComponent {
  modelPricingModalIsOpen: boolean = false;
  updateCommentModalData = {
    bodyNo: '',
    currentComment: '',
    updatedComment: '',
    vin: '',
  };
  unitSearchReserveRequest: UnitSearchReserveRequest = {
    reserve: '',
    onoroff: '',
    vin: '',
    userid: '',
    body_no: '',
  };
  commentModel: string = '';
  loadingAreaConfig: DsLoadingAreaConfiguration = {
    id: 'bodyLoading',
    loadingTitle: 'Loading...',
  };
  commentHistory: {
    zdate: string;
    ztime: string;
    zuser: string;
    zname: string;
    zreserve: string;
  }[] = [];
  addToast(tone: 'critical' | 'positive' | 'neutral', teastText: string): void {
    this.toastService.pushToast({
      id: 'error-toast',
      tone: tone,
      toastText: teastText,
    } as DsToastModel);
  }
  constructor(
    private readonly loadingAreaService: DsLoadingAreaService,
    private readonly stockService: CrossBorderService,
    private toastService: DsToastService
  ) {}

  onTextChange($event: Event) {
    const input = $event.target as HTMLInputElement;
    const value = input.value;
    this.updateCommentModalData.updatedComment = value.toString();
    console.log('Input value changed:', value);
  }

  closeModal() {
    this.modelPricingModalIsOpen = false;
    this.commentModel = '';
  }

  submit(onOrOff: string) {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    if (onOrOff === 'U') {
      this.commentModel = this.updateCommentModalData.currentComment;
    }
    if (this.commentModel === '') {
      this.addToast('critical', 'Comment cannot be empty');
      this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      return;
    }
    this.unitSearchReserveRequest.onoroff = onOrOff;
    this.unitSearchReserveRequest.reserve =
      this.updateCommentModalData.updatedComment;
    this.unitSearchReserveRequest.vin = this.updateCommentModalData.vin;
    this.unitSearchReserveRequest.userid =
      localStorage.getItem('euserid') || '';
    this.unitSearchReserveRequest.body_no = this.updateCommentModalData.bodyNo;
    this.stockService
      .unitSearchReserve(this.unitSearchReserveRequest)
      .subscribe(
        (response) => {
          console.log('Comment updated successfully:', response);
          this.addToast('neutral', response.message);
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          this.closeModal();
        },
        (error) => {
          console.error('Error updating comment:', error);
          this.addToast('critical', error);
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          this.modelPricingModalIsOpen = false;
        }
      );
  }
}
